import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { message } from 'antd'

import { API_SERVER } from '../config'

export const LOGIN            = API_SERVER + '/login'
export const CLONE_UPDATE     = API_SERVER + '/clone/update'
export const CLONE_INFO       = API_SERVER + '/clone/info'
export const CLONE_SAVE       = API_SERVER + '/clone/save'
export const CLONES_GET       = API_SERVER + '/clone/get-all'
export const CLONE_STOP       = API_SERVER + '/clone/stop'
export const CLONE_START      = API_SERVER + '/clone/start'
export const CLONE_DELETE     = API_SERVER + '/clone/delete'
export const CLONES_DISCOVER  = API_SERVER + '/clone/discover-all'
export const UPDATE_SETTINGS  = API_SERVER + '/clone/update-platform-settings'
export const LOGS             = API_SERVER + '/clone/logs/get'
export const CLONE_INVOICE_SEND = API_SERVER + '/clone/invoice/send'
// Task036: leads de los formularios de pretii.lat
export const LEADS_GET        = API_SERVER + '/lead/get'
export const LEAD_UPDATE      = API_SERVER + '/lead/update'
// Task037: secuencia de correos a leads
export const LEAD_EMAIL_PREVIEW = API_SERVER + '/lead/email/preview'
export const LEAD_EMAIL_SEND    = API_SERVER + '/lead/email/send'
// Task007: control de cobros de los clones
export const BILLING_SUMMARY     = API_SERVER + '/billing/summary'
export const BILLING_CLONE       = API_SERVER + '/billing/clone'
export const BILLING_SAVE        = API_SERVER + '/billing/save'
export const BILLING_CHARGE_SENT = API_SERVER + '/billing/charge-sent'
export const PAYMENT_REGISTER    = API_SERVER + '/payment/register'
export const PAYMENT_VOID        = API_SERVER + '/payment/void'

let localData = null

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if ( 401 === error.response.status ) { // Unauthorized
    localData = null
    clearLocalData()
  } else {
    return Promise.reject(error)
  }
})


export function requestToServer( bodyData, path ) {

  let localData = getLocalData()

  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  if ( localData && localData.token ) {
    headers.Token = localData.token
  }

  return new Promise((resolve, reject) => {

    axios.post(path, bodyData, {headers} ).then(r => {
      if (r){
        resolve( r.data ? r.data : null )
      } else {
        // el interceptor de arriba (líneas 20-29) resuelve el 401 con undefined en vez de
        // rechazar, así que este es el único lugar donde se puede detectar y avisar
        message.error('Sesión expirada, volvé a ingresar')
        reject(new Error('unauthorized'))
      }
    }).catch(e => {
      console.log('ERROR', e)
      // Task007: los errores de validación del módulo de cobros (400 con validation:true) traen un texto pensado
      // para el operador; el resto sigue mostrando el mensaje genérico (no se expone stderr de pm2 ni errores internos)
      const data = e && e.response && e.response.data
      message.error( data && data.validation ? data.e : 'No se pudo completar la operación' )
      reject(e)
    })

  })
}

// localdata management
export function setLocalData(data) {
  localData = data
  localStorage.removeItem('localData')
  localStorage.setItem('localData', JSON.stringify(localData) )
}
export function getLocalData() {

  if (localData) {
    return localData
  } else {
    let dataCookie = localStorage.getItem('localData')
    if ( dataCookie ) {
      localData = JSON.parse(dataCookie)
      return localData
    } else {
      return null
    }
  }
}
export function clearLocalData() {
  localData = null
  localStorage.removeItem('localData')
}